module.exports = __webpack_public_path__ + "static/media/microsoft.cb48d47b.png";